// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__-Fypw","inner":"Footer_inner__ac_Vi"};